var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#C6C9F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6211 33.9922C28.8906 33.9922 29.4766 33.1719 29.5742 31.9219C29.6719 30.0078 30.3359 29.0117 32.8555 27.5273C35.4336 25.9844 36.957 23.9141 36.957 20.8867C36.957 16.5703 33.4219 13.582 28.3242 13.582C24.418 13.582 21.4492 15.2227 20.2578 17.918C19.9062 18.6797 19.7305 19.3633 19.7305 20.2031C19.7305 21.3945 20.4141 22.1172 21.625 22.1172C22.6016 22.1172 23.207 21.6875 23.5977 20.4766C24.2227 18.3477 25.7852 17.1758 28.1484 17.1758C30.7461 17.1758 32.5234 18.7578 32.5234 21.0625C32.5234 22.9766 31.6836 24.1484 29.3203 25.5742C26.7812 27.0977 25.5703 28.7578 25.5703 31.2578V31.707C25.5703 32.9961 26.2539 33.9922 27.6211 33.9922ZM27.6211 42.293C29.0859 42.293 30.1992 41.1992 30.1992 39.7734C30.1992 38.3477 29.0859 37.2539 27.6211 37.2539C26.1953 37.2539 25.0625 38.3477 25.0625 39.7734C25.0625 41.1992 26.1953 42.293 27.6211 42.293Z",
    fill: "#8082C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownLogo);
export default __webpack_public_path__ + "static/media/UNKNOWN-LOGO.88c5be28f638f483458ab0d72ecec13b.svg";
export { ForwardRef as ReactComponent };